export default __webpack_public_path__ + "static/media/filter_icon_elevator_blue.ef9dff29.svg";